import { FunctionComponent } from 'react';
import { match } from 'react-router-dom';

import { renderRoutes } from 'scenes/Report/Report.helper';

import {
  PerformanceOverview,
  PerformanceOverviewBySegment,
  TransactionsByCashbackPercentage,
  TransactionsBySegment,
  TransactionVolume,
  RepeatVisitsByCashbackPercentage,
  RepeatVisitsBySegment,
  SubscriberPurchasePatterns,
  SubscriberPurchasePatternsBySegment,
  TopMetroAov,
  TopMetroTransactions,
  OnlineOfflineTransactions,
  TopMetroSales,
  Demographics,
  YearOverYear,
} from '.';

type Props = {
  match: match;
  whitelistReports?: string[];
};

const routes = (match: match) => [
  {
    path: `${match.url}/transactions`,
    component: TransactionsByCashbackPercentage,
  },
  {
    path: `${match.url}/transactionsBySegment`,
    component: TransactionsBySegment,
  },
  {
    path: `${match.url}/repeatVisits`,
    component: RepeatVisitsByCashbackPercentage,
  },
  {
    path: `${match.url}/repeatVisitsBySegment`,
    component: RepeatVisitsBySegment,
  },
  {
    path: `${match.url}/topMetroAov`,
    component: TopMetroAov,
  },
  {
    path: `${match.url}/topMetroTransactions`,
    component: TopMetroTransactions,
  },
  {
    path: `${match.url}/topMetroSales`,
    component: TopMetroSales,
  },
  {
    path: `${match.url}/performanceOverview`,
    component: PerformanceOverview,
  },
  {
    path: `${match.url}/performanceOverviewBySegment`,
    component: PerformanceOverviewBySegment,
  },
  {
    path: `${match.url}/transactionVolume`,
    component: TransactionVolume,
  },
  {
    path: `${match.url}/subscriberPurchasePatterns`,
    component: SubscriberPurchasePatterns,
  },
  {
    path: `${match.url}/subscriberPurchasePatternsBySegment`,
    component: SubscriberPurchasePatternsBySegment,
  },
  {
    path: `${match.url}/onlineOfflineTransactions`,
    component: OnlineOfflineTransactions,
  },
  {
    path: `${match.url}/shopperDemographics`,
    component: Demographics,
  },
  {
    path: `${match.url}/salesYearOverYear`,
    component: YearOverYear,
  },
  {
    path: `${match.url}/transactionsYearOverYear`,
    component: YearOverYear,
  },
  {
    path: `${match.url}/transactionsYearOverYearByVenueType`,
    component: YearOverYear,
  },
  {
    path: `${match.url}/salesYearOverYearByVenueType`,
    component: YearOverYear,
  },
];

const PerformanceReportsRoutes: FunctionComponent<Props> = ({
  match,
  whitelistReports,
}) => renderRoutes(routes(match), whitelistReports);

export default PerformanceReportsRoutes;
